import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResizeDirective } from './directives/resize/resize.directive';
import { SharedService } from '../core/services/store/shared-store/shared-storage.service';

import { ManagementService } from '../core/services/management/management.service';
import { AppRoutingModule } from '../core/guards/app-routing/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { WebsocketService } from '../core/services/emulator/websocket.service';
import { DragulaModule } from 'ng2-dragula';

import { PaydAuthGuard } from '../core/guards/portal/payd-auth.guard';
import { RolesService } from '../core/services/roles/roles.service';

import { Utils } from './utils/utils';
import { SubmissionService } from '../core/services/management/submission/submission.service';
import { EndpointTestingService } from '../core/services/endpoint-testing/endpoint-testing.service';

import { CdkTreeModule } from '@angular/cdk/tree';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatSnackBarModule} from '@angular/material/snack-bar';

import { RippleGlobalOptions, MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { CustomMatExpansionToggleDirective } from './directives/custom-mat-expansion-toggle/custom-mat-expansion-toggle.directive';
import { CountDownComponent } from '../modules/flow/components/count-down/count-down.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { EllipsisModule } from 'ngx-ellipsis';
import { SavingInProgressComponent } from './components/saving-in-progress/saving-in-progress.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {ToastBannerComponent} from './components/cms/toast-banner/toast-banner.component';
import { TooltipDirective } from './directives/tooltips/tooltip.directive';
import { CMSComponent } from './components/cms/cms.component';
import { MatRadioModule } from '@angular/material/radio';
import {CmsPopoverComponent} from './components/cms/cms-popover/cms-popover.component';
import { SharedServiceToken } from '../core/services/store/token-store/shared-storage.service-token';
import { ClickatellChipComponent } from './components/clickatell-chip/clickatell-chip.component';
import { ClickatellTreeComponent } from './components/clickatell-tree/clickatell-tree.component';
import { ClickatellSelectComponent } from './components/clickatell-select/clickatell-select.component';
import { LoadingIconComponent } from './components/loading-icon/loading-icon.component';
import { ClickatellExpansionPanelComponent } from './components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { MultiSelectDropdownComponent } from './components/form-controls/multi-select-dropdown/multi-select-dropdown.component';
import { NumberSelectorInputComponent } from './components/form-controls/number-selector-input/number-selector-input.component';
import {DisplayErrorPipe} from './utils/pipes/display-error-pipe';
import { ActiveFormDirective } from './directives/active-form/active-form.directive';
import { PathNameTrimmerDirective } from './directives/path-name-trimmer/PathNameTrimmer.directive';
import { FallbackImageDirective } from './directives/fallback-image/fallback-image.directive';
import {ShowMoreShowLessDirective} from './directives/path-name-trimmer/ShowMoreShowLess.directive';
import {OverflowTooltipDirective} from './directives/overflow-tooltip/overflow-tooltip.directive';
import {
    NextStepImageDirective
} from '../modules/flow/components/json-to-from/next-selector/directive/next-step-image.directive';
import { ClickatellButtonToggleComponent } from './components/clickatell-button-toggle/clickatell-button-toggle.component';
import { ClickatellFormValidationComponent } from './components/clickatell-form-validation/clickatell-form-validation.component';
import { ClickatellToastsComponent } from './components/clickatell-toasts/clickatell-toasts.component';
import {TruncateFileNamePipe} from './utils/pipes/truncate_file_name';
import { TruncateWithTooltipDirective } from './directives/truncate-with-tooltip/truncate-with-tooltip.directive';
import {FilterTreePipe} from './components/clickatell-tree/filterTreePipe';
import {SearchTreePipe} from './components/clickatell-tree/searchTreePipe';
import {TruncateFlowNamePipe} from "./utils/pipes/truncateFlowNamePipe";
import {TemplateContentButtonPipe} from "./utils/pipes/TemplateContentButtonPipe";
import {ArrayTemplateFilterPipe} from "./utils/pipes/ArrayTemplateFilterPipe";

const component = [
    SavingInProgressComponent,
    ToastBannerComponent,
    CmsPopoverComponent,
    ClickatellChipComponent,
    ClickatellTreeComponent,
    ClickatellSelectComponent,
    LoadingIconComponent,
    ConfirmationPopupComponent,
    ClickatellExpansionPanelComponent,
    MultiSelectDropdownComponent,
    NumberSelectorInputComponent,
    ClickatellButtonToggleComponent,
    ClickatellFormValidationComponent,
    ClickatellToastsComponent
];

const service = [
  ManagementService,
  WebsocketService,
  PaydAuthGuard,
  RolesService,
  Utils,
  SubmissionService,
  EndpointTestingService,
  SharedService,
  SharedServiceToken
];

const modules = [
  ReactiveFormsModule,
  FormsModule,
  AppRoutingModule,
  BrowserModule,
  MatChipsModule,
  MatFormFieldModule,
  MatIconModule,
  MatSlideToggleModule,
  BrowserAnimationsModule,
  CdkTreeModule,
  MatExpansionModule,
  MatButtonToggleModule,
  MatTooltipModule,
  MatSelectModule,
  MatTabsModule,
  MatDialogModule,
  MatToolbarModule,
  MatMenuModule,
  MatDividerModule,
  MatAutocompleteModule,
  MatInputModule,
  MatTableModule,
  MatSortModule,
  MatProgressBarModule,
  MatCheckboxModule,
  DragDropModule,
  MatRadioModule,
  MatSnackBarModule
];

const pipes = [
    DisplayErrorPipe,
    TruncateFileNamePipe,
    FilterTreePipe,
    SearchTreePipe,
    TruncateFlowNamePipe,
    TemplateContentButtonPipe,
    ArrayTemplateFilterPipe,
];

const directive = [
    CustomMatExpansionToggleDirective,
    ResizeDirective,
    ActiveFormDirective,
    PathNameTrimmerDirective,
    FallbackImageDirective,
    ShowMoreShowLessDirective,
    OverflowTooltipDirective,
    NextStepImageDirective
];

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
};

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        DragulaModule.forRoot(),
        EllipsisModule,
        modules,
    ],
    declarations: [
        component,
        directive,
        TooltipDirective,
        CMSComponent,
        pipes,
        TruncateWithTooltipDirective,
    ],
    exports: [
        modules,
        component,
        directive,
        DragulaModule,
        CMSComponent,
        TooltipDirective,
        MultiSelectDropdownComponent,
        NumberSelectorInputComponent,
        TruncateWithTooltipDirective,
        pipes
    ],
    providers: [
        service,
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig }
    ],
    entryComponents: [
        CountDownComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class SharedModule {}
